import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const HorarioClases = () => {
  const [clases, setClases] = useState([]);
  const [materia, setMateria] = useState('');
  const [horaInicio, setHoraInicio] = useState('08:00');
  const [horaFin, setHoraFin] = useState('09:00');

  const agregarClase = () => {
    if (materia.trim() === '') return;
    setClases([...clases, { materia, horaInicio, horaFin }]);
    setMateria('');
  };

  return (
    <div style={{ backgroundColor: '#F4F6FA', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <div style={{ padding: '20px', flex: 1 }}>
        <h2>Horario de Clases</h2>
        <div style={{ marginBottom: '10px' }}>
          <label>Materia:</label>
          <input type="text" value={materia} onChange={(e) => setMateria(e.target.value)} />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label>Hora de inicio:</label>
          <input type="time" value={horaInicio} onChange={(e) => setHoraInicio(e.target.value)} />
        </div>
        <div style={{ marginBottom: '10px' }}>
          <label>Hora de fin:</label>
          <input type="time" value={horaFin} onChange={(e) => setHoraFin(e.target.value)} />
        </div>
        <button onClick={agregarClase}>Agregar Clase</button>
        <ul>
          {clases.map((clase, index) => (
            <li key={index}>{`${clase.materia}: ${clase.horaInicio} - ${clase.horaFin}`}</li>
          ))}
        </ul>
      </div>
      <Footer />
    </div>
  );
};

export default HorarioClases;
